import { render } from "./HeroiconsSolidPencilAlt.vue?vue&type=template&id=cac6e61c"
const script = {}

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPencilAlt.vue"]])

export default __exports__